import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';

const warrantyProcess = [
  {
    'name': 'Ingreso de Garantías',
    'path': paths.WarrantyInsert,
    'resource': resources.WarrantyInsert,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
  {
    'name': 'Ingreso de Garantías Excel',
    'path': paths.ExcelWarrantyInsert,
    'resource': resources.ExcelWarrantyInsert,
    'scopes': [scopes.See, scopes.Create],
    'icon': 'dateManagement',
  },
];

const warrantyIncomeQuery = [
  {
    'name': 'Garantías',
    'path': paths.WarrantyQuery,
    'resource': resources.WarrantyQuery,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
  {
    'name': 'Garantías Procesadas',
    'path': paths.ProcessedWarranty,
    'resource': resources.ProcessedWarranty,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
  {
    'name': 'Facturacion de Garantías',
    'path': paths.WarrantyInvoicing,
    'resource': resources.WarrantyInvoicing,
    'scopes': [scopes.See, scopes.Edit],
    'icon': 'invoicesDocuments',
  },
];

const warrantyIncomeMaintenance = [
  {
    'name': 'Códigos de Error',
    'path': paths.WarrantyErrorCodes,
    'resource': resources.WarrantyErrorCodes,
    'scopes': [scopes.See, scopes.Edit, scopes.Create],
    'icon': 'parameterConfig',
  },
  {
    'name': 'Códigos de Tareas',
    'path': paths.WarrantyTasksCodes,
    'resource': resources.WarrantyTasksCodes,
    'scopes': [scopes.See, scopes.Edit, scopes.Create],
    'icon': 'parameterConfig',
  },
];

const warrantyOutcome = [
  {
    'name': 'Reporte de Garantías',
    'path': paths.WarrantyReport,
    'resource': resources.WarrantyReport,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
  {
    'name': 'Tasa de Error',
    'path': paths.WarrantyErrorRate,
    'resource': resources.WarrantyErrorRate,
    'scopes': [scopes.See],
    'icon': 'dateManagement',
  },
];


const getWarrantiesProcessOptions = (permissions) => {
  const options = [{
    'name': 'Formularios',
    'options': filterByPermissions(permissions, warrantyProcess),
  }];

  return options.filter((item) => item.options.length);
};


const getWarrantiesIncomeOptions = (permissions) => {
  const options = [{
    'name': 'Consultas',
    'options': filterByPermissions(permissions, warrantyIncomeQuery),
  },
  {
    'name': 'Mantenimiento',
    'options': filterByPermissions(permissions, warrantyIncomeMaintenance),
  }];

  return options.filter((item) => item.options.length);
};

const getWarrantiesOutcomeOptions = (permissions) => {
  const options = [
    {
      'name': 'Reportes',
      'options': filterByPermissions(permissions, warrantyOutcome),
    },
  ];

  return options.filter((item) => item.options.length);
};

export const getWarrantiesOptions = (permissions) => {
  const options = [
    {
      'name': 'Entrada',
      'options': getWarrantiesIncomeOptions(permissions),
    },
    {
      'name': 'Proceso',
      'options': getWarrantiesProcessOptions(permissions),
    },
    {
      'name': 'Salida',
      'options': getWarrantiesOutcomeOptions(permissions),
    },
  ];
  
  return options.filter((item) => item.options.length);
};

export const warrantiesOptions = [
  ...warrantyProcess,
  ...warrantyIncomeQuery,
  ...warrantyIncomeMaintenance,
];
